<svelte:options customElement="profile-main" />

<script>
    import { onMount } from "svelte";
    import { loadAssets, baseUrl } from "../../../../../SharedSvelte/Common.svelte";
    import { appProfileState } from "../../state/ApplicationState.svelte";
    import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
    import GlobalLoader from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import ProfileLayout from './ProfileLayout.svelte';
    
    let apiPromise = $state(fetchProfileContent()); 

    async function fetchProfileContent() {
        Loader.display();
        
        try {
            const response = await fetch(`${baseUrl}Options/Profile/ProfileContent`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
                },
                // body: JSON.stringify({
                //     id
                // })
            });

            window.scrollTo(0, 0);

            if (!response.ok) {
                const error = `Server exception: ${response.status} ${response.statusText}`;
                //prompt.showMessage(error, "Information");
                throw new Error(error);
            }

            const data = await response.json();
            appProfileState.memberDetails = data.memberDetails;
            appProfileState.isUserSubscriber = data.isUserSubscriber;
            appProfileState.contactMethods = data.contactMethods;
            appProfileState.documentDeliveryMethods = data.documentDeliveryMethods;

            return data; // Resolves the Promise with the fetched data
        } catch (error) {
            console.error("Error fetching profile content:", error);
            return Promise.reject(error); // Rejects the Promise with the error
        } finally {
            Loader.hide();
        }
    }

    onMount(async () => {
        setTimeout(() => {
            loadAssets("profile-main");
        }, 10);
    });
</script>

{#await apiPromise}
    <div>Loading...</div>
{:then data}
    <!-- <pre>{JSON.stringify(data)}</pre>
    <pre>{JSON.stringify(appProfileState)}</pre> 
    <pre>{JSON.stringify(appProfileState.sideMenuItems)}</pre> -->
    
    <ProfileLayout />
    
<!-- {:catch error}
    <div class="text-danger">{error}</div> -->
{/await}

<GlobalLoader />


